import './modal-kform.scss';

export default class ModalKformController {
	/* @ngInject */
	/**
	 * @param {import('angular').ui.bootstrap.IModalInstanceService} $uibModalInstance
	 * @param {import('@knitiv/api-client-javascript').KNode} isa
	 * @param {string} isaName
	 * @param {string} query
	 */
	constructor(
		$uibModalInstance,
		isa,
		isaName,
		query,
	) {
		this.$uibModalInstance = $uibModalInstance;

		this.create = true;
		this.isa = isa;
		this.isaName = isaName;

		this.options = {
			name:     query,
			params:   {},
			parent:   null,
			tab:      'form',
			tree:     false,
			viewMode: 1,
		};
	}

	cancel() {
		this.$uibModalInstance.dismiss('cancel');
	}

	/**
	 * @param {import('@knitiv/api-client-javascript').KNode} kid
	 * @param {string} name
	 */
	submit(kid, name) {
		this.$uibModalInstance.close({ kid, name });
	}
}
